// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shadow[data-v-be30a56e] {\n  -webkit-box-shadow: 0px 4px 18px 0px rgba(0, 0, 0, 0.05);\n          box-shadow: 0px 4px 18px 0px rgba(0, 0, 0, 0.05);\n}\n", ""]);
// Exports
module.exports = exports;
